module.exports = __webpack_public_path__ + "media/images/webpage/hotels/93/meal-a05231d72289406bff817dd6f55835eb.webp";